<template>
  <div class="fts-radio-template" :class="{'comfort-design': comfortDesign}">
    <div
      v-for="option in options"
      :key="option[optionIdKey]"
      class="radio-wrapper"
    >
      <label
        class="radio-option radio-option--template-1 "
        :class="{'radio-option--active': mutableValueId === option[optionIdKey]}"
        v-if="item.id === 'advanced-template-1'"
      >
        <fts-file-content
          file-type="image"
          :file-path="filePath(option.image, item.imageId)"
          :image-width="comfortDesign ? 260 : 194"
          :image-height="comfortDesign ? 160 : 120"
        />
        <div class="radio-option-label">
          <fts-radio
            :group-name="`radio-group-${uid}`"
            :option-id="option[optionIdKey]"
            :option-label="option[optionLabelKey]"
            :option-value="option[optionValueKey]"
            v-model="mutableValue"
            :value-id.sync="mutableValueId"
            :comfort-design="comfortDesign"
          />
        </div>
      </label>
      <fts-radio
        :group-name="`radio-group-${uid}`"
        :option-id="option[option.optionIdKey]"
        :option-label="option[optionLabelKey]"
        :option-value="option[optionValueKey]"
        v-model="mutableValue"
        :value-id.sync="mutableValueId"
        :comfort-design="comfortDesign"
        v-else
      />
    </div>
  </div>
</template>

<script>
import commons from '../commons/commons';

import FTSRadio from "./FTSRadio";
import FTSFileContent from './file/FTSFileContent';

export default {
  props: {
    item: Object,
    connectionId: [String, Number],
    options: Array,
    optionIdKey: {
      type: String,
      default: 'id'
    },
    optionLabelKey: {
      type: String,
      default: 'name'
    },
    optionValueKey: {
      type: String,
      default: 'value'
    },
    value: {
      required: true
    },
    valueId: [String, Number],
    comfortDesign: Boolean,
  },
  components: {
    'fts-radio': FTSRadio,
    'fts-file-content': FTSFileContent
  },
  data: () => ({
    uid: null
  }),
  methods: {
    filePath(file, informationId) {
      return file && commons.getFilePath(file.path, `${this.connectionId}-${informationId}`);
    }
 },
 computed: {
  mutableValue: {
    get() {
      return this.value;
    },
    set(val) {
      this.$emit("update:value", val);
    }
  },
  mutableValueId: {
    get() {
      return this.valueId;
    },
    set(val) {
      this.$emit("update:valueId", val);
    }
  }
 },
 mounted() {
  this.uid = this._uid;
 }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-radio-template {
  .radio-wrapper {
    &:not(:last-child) {
      margin-bottom: 0.75rem;
    }
  }
  .radio-option--template-1 {
    width: calc(194px + 18px);
    border: 1px solid var(--fts-border);
    padding: 0.5rem;
    display: inline-block;
    border-radius: $border-radius;
    cursor: pointer;
    &.radio-option--active {
      border-color: var(--fts-primary);
    }
    .radio-option-label {
      margin-top: 0.625rem;
    }
  }
  &.comfort-design {
    .radio-wrapper {
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
    }
    .radio-option--template-1 {
      width: calc(260px + 18px);
      border-radius: $comfort-border-radius; 
      .radio-option-label {
        margin-top: 1rem;
      }
    }
  }
}
</style>